export default __webpack_public_path__ + "static/media/feature_teaser_storybook_example.cdcaa412.svg";